import React, { useState } from "react";
import "./style.css";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";

export default function Survey({
  value = null,
  onChange = () => {},
  max = 5,
  size = 36, // حجم النجوم أكبر
  labels = [],
  rtl = false,
  lang = "ar",
  onCommentChange = () => {},
  commentRequiredThreshold = 3, // textarea إجبارية إذا <= 3
}) {
  const [hover, setHover] = useState(null);
  const [localRating, setLocalRating] = useState(value);
  const [comment, setComment] = useState("");

  const displayed = hover !== null ? hover : localRating;

  const handleClick = (idx) => {
    setLocalRating(idx);
    onChange(idx);
  };

  const showTextarea = true; // textarea ظاهرة دائمًا
  const commentRequired =
    localRating !== null && localRating <= commentRequiredThreshold;

  return (
    <div
      className={`survey-container ${rtl ? "rtl" : ""}`}
      dir={lang == "ar" ? "rtl" : "ltr"}
    >
      <div className="stars-wrapper">
        {[...Array(max)].map((_, i) => {
          const idx = i + 1;
          const filled = localRating !== null && idx <= localRating;
          const hovered = hover !== null && idx <= hover;

          return (
            <button
              key={idx}
              type="button"
              className={`star-btn ${filled ? "filled" : ""} ${
                hovered ? "hover" : ""
              }`}
              onClick={() => handleClick(idx)}
              onMouseEnter={() => setHover(idx)}
              onMouseLeave={() => setHover(null)}
              style={{ width: size, height: size }}
            >
              <svg
                viewBox="0 0 24 24"
                width={size}
                height={size}
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M12 .587l3.668 7.431L23.6 9.75l-5.4 5.27L19.336 24 12 19.897 4.664 24 5.8 15.02 0.4 9.75l7.932-1.732z"
                  className="star-path"
                />
              </svg>
            </button>
          );
        })}
      </div>

      {showTextarea && (
        <textarea
          value={comment}
          onChange={(e) => {
            setComment(e.target.value);
            onCommentChange(e.target.value);
          }}
          placeholder={lang === "ar" ? " اكتب ملاحظتك " : "Write your comment"}
          style={{
            width: "100%",
            marginTop: "10px",
            padding: "10px",
            fontSize: "16px",
            minHeight: "100px",
            resize: "none",
          }}
        />
      )}

      {commentRequired && comment.trim().length === 0 && (
        <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
          {lang === "ar" ? "هذا الحقل اجباري" : "This field is required"}
        </div>
      )}
    </div>
  );
}
